export const RESPONSE_STATUS = {
    'Error': 'ERROR',
    'Success': 'SUCCESS'
};
